import {routesNames} from "@/core/constants";
import AnuenciaFornecedorView from "@/views/pages/adesao/anuenciaFornecedor/AnuenciaFornecedorView";
import AdesaoPublicaView from "@/views/pages/adesao/publica/AdesaoPublicaView.vue";

export default [
	{
		name: routesNames.ADESAO.ANUENCIA,
		path: '/adesao/anuencia/:hash',
		component: AnuenciaFornecedorView,
		meta: {
			title: 'Anuência do Fornecedor'
		},
	},
	{
		name: routesNames.ADESAO.ADESAO_PUBLICA_VIEW,
		path: '/adesao/publica/:id',
		component: AdesaoPublicaView,
		meta: {
			page: {
				title: 'Adesão Pública'
			},
		},
	},
]
